import React, {useState} from "react";
import Modal from 'react-modal';

Modal.setAppElement("#root");
const BillingPayCard = () => {
    const [modalIsOpen,setModalIsOpen] = useState(false)
    return (
        <>
            <div className="cpay__box__left billing__pay-card">
                <h2 className="cpay__box__left-txt text-jost-sb-22">Payment method</h2>
                <div className="cpay__box__left-card">
                    <input className="cardpay" id="" type="radio" name="payment"/>
                    <img src={require("../../assets/images/card/card_1.svg").default}
                         alt=""/>
                    <img src={require("../../assets/images/card/card_2.svg").default}
                         alt=""/>
                    <img src={require("../../assets/images/card/card_3.svg").default}
                         alt=""/>
                </div>
                <div className="cpay__box__left-cdetail">
                    <div className="cpay__box__left-cname">
                        <label htmlFor="" className="label__set">Name On Card*</label>
                        <input className="form__input-md" type="text" placeholder="" name="" required/>
                    </div>
                    <div className="cpay__box__left__cdetail">
                        <div className="cpay__box__left__cdetail-cnum">
                            <label htmlFor="" className="label__set">Name Number*</label>
                            <input className="form__input-md" type="text" placeholder="" name="" required/>
                        </div>
                        <div className="cpay__box__left__cdetail-edate">
                            <label htmlFor="" className="label__set">Expiry Date</label>
                            <input className="form__input-md" type="text" placeholder="" name="" required/>
                        </div>
                        <div className="cpay__box__left__cdetail-cvv">
                            <label htmlFor="" className="label__set">CV2</label>
                            <input className="form__input-md" type="text" placeholder="" name="" required/>
                        </div>
                        <div className="cpay__box__left__cdetail-warn">
                            <a href="#">
                                <img src={require("../../assets/images/warning/warning_pay.svg").default}
                                     alt=""/>
                                What is this? </a>
                        </div>
                    </div>

                </div>
                <div className="cpay__box__left__check">
                    <label htmlFor="bill_add" className="checkbox"></label>
                    <input type="checkbox" id="bill_add" name="" value=""/>
                    <span className="text-jost-sb-19">Billing details are the same as Club Address</span>
                </div>
                <div className="cpay__box__left__add">
                    <input className="form__input-md" type="text" placeholder="Start to type your address…"
                           name="add_1" required/>
                    <input className="form__input-md" type="text" placeholder="Address Line 2" name="add_2"
                           required/>
                    <input className="form__input-md" type="text" placeholder="Town" name="town" required/>
                    <input className="form__input-md" type="text" placeholder="County*" name="country"
                           required/>

                    <input className="form__input-md" type="text" placeholder="Postcode*" name="postcode"
                           required/>
                </div>
                <div className="cpay__box__left-paypal">
                    <input id="" type="radio" name="payment"/>
                    <img src={require("../../assets/images/card/card_4.svg").default}
                         alt=""/>
                </div>
                <Modal isOpen={modalIsOpen}
                       style={{
                           overlay: {
                               zIndex:'2',
                               backgroundColor: 'transparent',

                           },
                           content: {
                               position: 'absolute',
                               top: '45%',
                               left: '12%',
                               right: '12%',
                               bottom: '0',
                               border: '1px solid #ccc',
                               background: '#fff',
                               overflow: 'auto',
                               WebkitOverflowScrolling: 'touch',
                               borderRadius: '4px',
                               outline: 'none',
                               padding: '20px',
                               display:'flex',
                               alignItems:'center',
                               justifyContent:'center',
                               flexDirection:'column'
                           }
                       }}
                >
                    <button target="_self" className="modal-content--cross" onClick={() => setModalIsOpen(false)}>
                        <img src={require("../../../src/assets/images/cross/Group 6926.svg").default} alt=""/>
                    </button>
                    <div className="modal_billing">


                        <div className="modal-content">

                            <h1 className="modal-content--title text-jost-sb-50">Payment Method Updated!</h1>
                            <p className="modal-content--para text-ops-rg-16">We can confirm your subscription payment information has been successfully updated..</p>
                            <div className="modal-content--links">
                                <button href="/#" target="_self" className="res-btn-primary" onClick={() => setModalIsOpen(false)}>ok, thanks</button>
                            </div>
                        </div>
                    </div>
                </Modal>
<div className="cpay__box__left-link">
                <a href="/#" target="_self" className="res-btn-primary" onClick={() =>setModalIsOpen(true)}>SAVE CHANGES</a>
</div>
            </div>


        </>
    );
};
export default BillingPayCard;